export enum SlideOverForms {
  CreateRunTemplateStages,
  CreateRunTemplateTasks,
  MoveRunTemplateStages,
  EditRunTemplateTasks,
  EditRunTemplateTaskSchedule,
  AddRunTemplateChild,
}
